import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.FirstStartModule.CreateOrganisationPopup.PopupTitle', {
    lastStep: 'Last step:',
    title: 'Connect your accounting system',
    description1: 'Connecting the accounting system allows you to test',
    description2: 'all the features within your trial.',
});
